import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import type { createBrowserRouter } from 'react-router'
import { RouterProvider } from 'react-router'
import { Toaster } from 'sonner'
import { TooltipProvider } from '@/components/ui/misc'
import { SessionExpiredDialog } from './SessionExpiredDialog'
import { VersionPrompt } from './VersionPrompt'

type Router = ReturnType<typeof createBrowserRouter>

export function createAppQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: { staleTime: 30_000, retry: (count, error) => count < 2 && !(error as { status?: number }).status },
    },
  })
}

export function AppProviders({ router, queryClient }: { router: Router; queryClient: QueryClient }) {
  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider delayDuration={300}>
        <RouterProvider router={router} />
        <SessionExpiredDialog />
        <VersionPrompt />
        <Toaster position="bottom-right" closeButton toastOptions={{ duration: 5000 }} style={{ zIndex: 70 }} />
      </TooltipProvider>
    </QueryClientProvider>
  )
}
